import * as React from 'react';
import { connect } from 'react-redux';
import { Dialog } from '@siteground/styleguide';

import {
  closeSGDialog,
  subscribeSGDialogClosed,
  subscribeSGDialogOpened,
  unmountDialog
} from '../../actions/sg-dialog';

class SGDialog extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      opened: this.props.initialOpenedState,
      startedClosing: false
    };
  }

  render() {
    const {
      align,
      children,
      closeSGDialog,
      density,
      disableClose,
      footer,
      icon,
      iconColor,
      iconSize,
      id,
      onCloseHandler,
      requested,
      size,
      state,
      title,
      subTitle
    } = this.props;

    const { opened, startedClosing } = this.state;
    const shouldDisableClose = requested > 0 && !startedClosing;

    if (opened || startedClosing) {
      return (
        <Dialog
          align={align}
          density={density}
          disableClose={disableClose || shouldDisableClose}
          footer={footer}
          icon={icon}
          iconColor={iconColor}
          iconSize={iconSize}
          size={size}
          state={state}
          title={title}
          subTitle={subTitle}
          triggerClose={startedClosing}
          data-e2e={`sg-dialog-${id}`}
          onCloseHandler={() => {
            closeSGDialog(id);
            if (onCloseHandler) {
              onCloseHandler();
            }
          }}
        >
          {children}
        </Dialog>
      );
    }

    return null;
  }

  componentDidMount() {
    const { id, subscribeSGDialogOpened, subscribeSGDialogClosed, unmountDialog } = this.props;

    subscribeSGDialogOpened(id, () =>
      this.setState({
        opened: true,
        startedClosing: false
      })
    );

    subscribeSGDialogClosed(id, () => {
      const previouslyOpened = this.state.opened;

      this.setState({
        opened: false,
        startedClosing: previouslyOpened
      });
    });
  }

  componentWillUnmount() {
    const { id, unmountDialog } = this.props;
    unmountDialog(id);
  }
}

const mapStateToProps = (store, { id }) => {
  return {
    initialOpenedState: Boolean(store.dialog[id])
  };
};

export default connect(mapStateToProps, {
  subscribeSGDialogOpened,
  subscribeSGDialogClosed,
  unmountDialog,
  closeSGDialog
})(SGDialog);
